import { useLanguage } from "../context/LanguageContext";

export function Loading({ label }: { label?: string }) {
  const { isArabic } = useLanguage();
  return <div className="loading" role="status"><span className="loading__seed" aria-hidden="true" /><p>{label ?? (isArabic ? "جارٍ تحميل مساحتك…" : "Loading your workspace…")}</p></div>;
}
